
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { User } from "../types";
import { toast } from "sonner";
import { updateAuthMetadata } from "@/context/auth/profile/updateAuthMetadata";

export const useProfileManagement = (
  user: User | null,
  setUser: (user: User | null) => void,
  setIsLoading: (loading: boolean) => void
) => {
  const updateProfile = async (profileData: {
    first_name?: string;
    last_name?: string;
    company?: string;
    phone?: string;
    role?: string;
    preferred_language?: string;
  }): Promise<boolean> => {
    if (!user) {
      toast.error("Du måste vara inloggad för att uppdatera profilen");
      return false;
    }

    setIsLoading(true);
    
    try {
      // Update profile using secure RPC function
      const { error: profileError } = await supabase
        .rpc('update_profile_secure', {
          p_first_name: profileData.first_name,
          p_last_name: profileData.last_name,
          p_company: profileData.company,
          p_role: profileData.role,
          p_preferred_language: profileData.preferred_language,
        });

      if (profileError) throw profileError;

      // Update local user state
      setUser({
        ...user,
        ...profileData,
        full_name: `${profileData.first_name || ''} ${profileData.last_name || ''}`.trim()
      });

      toast.success("Profilen har uppdaterats!");
      return true;
    } catch (error: any) {
      console.error("Profile update error:", error);
      toast.error(error.message || "Kunde inte uppdatera profilen. Försök igen.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateProfile };
};
